import type { IPaymentHistoryApiPort } from '@subscriptions/application/ports';
import type { PaymentHistoryFilterDto, PaymentHistoryPageViewDto } from '@subscriptions/application/dtos';
import type { PaymentHistoryHttpClientType } from '@subscriptions/infrastructure/api/PaymentHistoryHttpClient';
import type { PaymentHistoryApiMapperType } from '@subscriptions/infrastructure/mappers/PaymentHistoryApiMapper';

/**
 * Creates the payment history repository implementing IPaymentHistoryApiPort.
 * Orchestrates HTTP client and mapper to fulfill application contracts.
 */
export const createPaymentHistoryApiRepository = (props: {
  httpClient: PaymentHistoryHttpClientType;
  mapper: PaymentHistoryApiMapperType;
}): IPaymentHistoryApiPort => {
  const { httpClient, mapper } = props;

  const list = async (params: PaymentHistoryFilterDto): Promise<PaymentHistoryPageViewDto> => {
    const apiResponse = await httpClient.list({
      page: params.page,
      pageSize: params.pageSize,
      blockUuid: params.blockUuid,
    });
    return mapper.mapApiResponseListToPage(apiResponse);
  };

  return { list };
};
